var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-sm btn-xml btn-block text-export",on:{"click":function($event){return _vm.getXML()}}},[_vm._v("\n      Exportar XML do registro\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }